import { useScheduleConfig } from "./scheduleConfig";

const scheduleFiles = require.context(
  "../../data/schedules",
  true,
  /schedule\.json$/
);

export const useSchedule = () => {
  const { loading, error, solution } = useScheduleConfig();

  if (loading || error || solution === null || solution === 0) {
    return {
      loading,
      error,
      data:
        !loading && !error && solution === 0
          ? { solution, weeks: null }
          : null,
    };
  }

  const schedule = scheduleFiles(`./solution${solution}/schedule.json`);
  return {
    loading: false,
    error: null,
    data: { solution, weeks: schedule.default || schedule },
  };
};

export const getTeamSchedule = (weeks, teamName) =>
  weeks.map((matchups, i) => {
    const game = matchups.find((m) => m.some((t) => t.Name === teamName));
    if (!game) {
      return { week: i + 1, bye: true };
    }
    const opponent = game.find((t) => t.Name !== teamName);
    return { week: i + 1, opponent };
  });

export const getTeam = (weeks, teamName) => {
  for (const matchups of weeks) {
    for (const game of matchups) {
      const team = game.find((t) => t.Name === teamName);
      if (team) return team;
    }
  }
  return null;
};

export const teamPath = (name) =>
  `/fumbbl/NCBB/schedule/${encodeURIComponent(name)}`;
